import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthLoginGuard implements CanActivate {
  #authService = inject(AuthService);
  #router = inject(Router);

  canActivate(): boolean {
    if (this.#authService.isLoggedIn()) {
      this.#router.navigate(['/']);
      return false;
    } else {
      return true;
    }
  }
}
